import { Button } from '@mui/material'
import React from 'react'
import '../style/common/MButton.scss'
const MButton = (props) => {
    const { variant = 'contained', className = '', btnName = '', onClick = () => { }, id = `btnName-${Math.random()}`, onKeyDown = () => { }, startIcon = null, endIcon = null, style = {}, disabled = false, ...restProps } = props
    return (
        <>
            <Button
                className={className === '' ? variant === 'contained' ? 'btn-orange' : variant === 'outlined' ? 'btn-orange-outline' : '' : className}
                variant={variant}
                onClick={onClick}
                id={id}
                onKeyDown={onKeyDown}
                startIcon={startIcon}
                endIcon={endIcon}
                disabled={disabled}
                style={{ ...style }}
                {...restProps}
            >{btnName}</Button>
        </>
    )
}

export default MButton